<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div class="account-settings-info-view">
    <a-row :gutter="16"
           type="flex"
           justify="center">
      <a-col :order="isMobile ? 2 : 1"
             :md="24"
             :lg="16">
        <a-form :form="form"
                layout="vertical">
          <a-form-item :labelCol="labelCol"
                       :wrapperCol="wrapperCol"
                       label="账户名称">
            <a-input disabled
                     placeholder="账户名称"
                     v-decorator="['username']" />
          </a-form-item>
          <a-form-item :labelCol="labelCol"
                       :wrapperCol="wrapperCol"
                       label="昵称">
            <a-input placeholder="昵称"
                     v-decorator="['nickName']" />
          </a-form-item>
          <a-form-item :labelCol="labelCol"
                       :wrapperCol="wrapperCol"
                       label="真实姓名">
            <a-input placeholder="真实姓名"
                     v-decorator="['realName']" />
          </a-form-item>
          <a-form-item :labelCol="labelCol"
                       :wrapperCol="wrapperCol"
                       label="手机">
            <a-input placeholder="手机"
                     v-decorator="[ 'phone', validatorRules.phone]" />
          </a-form-item>
          <a-form-item :labelCol="labelCol"
                       :wrapperCol="wrapperCol"
                       label="邮箱">
            <a-input placeholder="请输入邮箱"
                     v-decorator="[ 'email', {rules: [{ pattern: '^[A-Za-z0-9-_\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$', message: '请输入正确的邮箱号' }]}]" />
          </a-form-item>
          <a-form-item :labelCol="labelCol"
                       :wrapperCol="wrapperCol"
                       label="部门名">
            <a-input disabled
                     placeholder="部门名"
                     v-decorator="[ 'deptName']" />
          </a-form-item>
          <a-form-item :labelCol="labelCol"
                       :wrapperCol="wrapperCol"
                       label="水司名">
            <a-input disabled
                     placeholder="水司名"
                     v-decorator="[ 'tenantName']" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary"
                      :loading="confirmLoading"
                      @click="updateData">{{ $t('account.settings.basic.update') }}</a-button>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col :order="1"
             :md="24"
             :lg="8"
             :style="{ minHeight: '180px' }">
        <div class="ant-upload-preview"
             @click="editImg">
          <a-icon type="cloud-upload-o"
                  class="upload-icon" />
          <div class="mask">
            <a-icon type="plus" />
          </div>
          <img :src="option.img" />
        </div>
      </a-col>
    </a-row>

    <avatar-modal ref="modal"
                  @ok="setavatar" />
  </div>
</template>

<script>
import pick from 'lodash.pick'
import { mapActions, mapGetters, mapState } from 'vuex'
import AvatarModal from './AvatarModal'
import { baseMixin } from '@/store/app-mixin'

export default {
  mixins: [baseMixin],
  components: {
    AvatarModal
  },
  data () {
    return {
      record: {},
      confirmLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      validatorRules: {
        phone: {
          rules: [
            {
              pattern: /^[1][3,4,5,7,8][0-9]{9}$/,
              message: '请输入正确的手机号码!'
            }
          ]
        },
        email: {
          rules: [
            {
              pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
              message: '请输入正确的邮箱!'
            }
          ]
        }
      },
      // cropper
      preview: {},
      option: {
        img: '',
        info: true,
        size: 1,
        outputType: 'jpeg',
        canScale: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 180,
        autoCropHeight: 180,
        fixedBox: true,
        // 开启宽度和高度比例
        fixed: true,
        fixedNumber: [1, 1]
      },
      url: 'manager/users'
    }
  },
  methods: {
    ...mapGetters(['nickname', 'avatar', 'userInfo']),
    // 修改头像
    editImg () {
      console.log(this.option.img)
      this.$refs.modal.edit(this.option.img)
    },
    // 更新数据
    updateData () {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          const params = Object.assign(this.record, values)
          if (params.deptName) {
            delete params.deptName
          }
          delete params.tenantName
          this.$http
            .put(this.url, params)
            .then(res => {
              if (res.code == 0) {
                this.$message.success(res.message)
                this.getUserList()
              } else {
                this.$message.warning(res.message)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    setavatar (url) {
      this.option.img = url
      this.$store.commit('SET_URL', url)
    },
    getUserList () {
      this.record = this.userInfo()
      console.log(this.record)
      this.option.img =
        this.$store.state.user.headUrl ||
        'https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png'
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.record, 'username', 'nickName', 'realName', 'phone', 'email'))
        this.form.setFieldsValue({ deptName: this.record.dept ? this.record.dept.deptName : '', tenantName: this.record.tenant ? this.record.tenant.tenantName : '' })
      })
    }
  },
  created () {
    this.getUserList()
  }
}
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
